import { Component, EventEmitter, Input, Output } from "@angular/core";
import { AreaOfWork } from "@models/areaOfWork.model";
import { Development } from "@models/development.model";
import { DownloadCsv } from "@models/download-csv.model";
import { Project } from "@models/project.model";
import { currencyFormatter } from "src/app/constants/charts-const";
import { DownloadCsvServiceService } from "@services/download-csv-service.service";
import { AreaOfWorkService } from "@services/area-of-work.service";
import { CommonServiceService } from "@services/common-service.service";
@Component({
  selector: "app-development-project-details",
  templateUrl: "./development-project-details.component.html",
  styleUrls: ["./development-project-details.component.scss"],
})
export class DevelopmentProjectDetailsComponent {
  _download: DownloadCsv[] = [];

  projectStatus: string[] = [];
  @Input()
  set development(development: Development) {
    this._download = [];
    this._development = development;
    if (this._development) {
      this.generateProjects();
      this.generateDownloadableData();
    }
  }

  get development(): Development {
    return this._development;
  }

  @Output() selectedProjectId = new EventEmitter<string>();

  selectedProject: Project | undefined = undefined;

  _development!: Development;
  displayedColumns = [
    "AREA OF WORK",
    "5-YEAR CAPITAL NEEDS",
    "20-YEAR CAPITAL NEEDS",
    "PROJECTS",
    "BUDGET",
    "FUNDING SOURCE",
    "PROJECT STATUS",
  ];
  projectDetails: AreaOfWork[] = [];
  fiveYearCapitalNeeds = 0;
  twentyYearCapitalNeeds = 0;
  constructor(
    private excelService: DownloadCsvServiceService,
    private areaofWorkService: AreaOfWorkService,
    private commonServiceService: CommonServiceService,
  ) {
    // console.log(this._development.areasOfWork);
    // console.log(areaofWorkService.getItem());
  }
  generateProjects(): void {
    this.projectDetails = this._development.areasOfWork
      .map((a) => {
        this.fiveYearCapitalNeeds += a.fiveYearCapitalNeeds;
        this.twentyYearCapitalNeeds += a.twentyYearCapitalNeeds;

        return a;
      })
      .flat();

    // console.log(this.projectDetails);
  }

  loadProjectDetails(projectId: string) {
    this.selectedProjectId.emit(projectId);
  }

  generateDownloadableData(): void {
    this.getHeader();

    this._development.areasOfWork.forEach((x) => {
      if (x.projects.length > 0) {
        x.projects.forEach((pj, i) => {
          this._download.push({
            areaOfwork: i === 0 ? x?.name : "",
            fiveYrCapital: i === 0 ? currencyFormatter.format(x?.fiveYearCapitalNeeds) : "",
            twentyYrCapital: i === 0 ? currencyFormatter.format(x?.twentyYearCapitalNeeds) : "",
            projectName: this.commonServiceService.removeStringAfterParenthesesAndTitleCase(
              pj.name,
            ),
            budget: currencyFormatter.format(pj.projectTotalBudget),
            fundingSource: pj.funding
              .flatMap((ca) => ca.fundingCategory)
              .filter((item, pos, ar) => ar.indexOf(item) === pos)
              .join(", "),
            projectStatus: this.getProjectstatus(pj),
          });
        });
      } else {
        this._download.push({
          areaOfwork: x?.name,
          fiveYrCapital: currencyFormatter.format(x?.fiveYearCapitalNeeds),
          twentyYrCapital: currencyFormatter.format(x?.twentyYearCapitalNeeds),
          projectName: "",
          budget: "",
          fundingSource: "",
          projectStatus: "",
        });
      }
    });

    this.getSummary();
  }

  private getHeader() {
    this._download.push({
      areaOfwork: "Area Of Work",
      fiveYrCapital: "5-Year Capital Needs",
      twentyYrCapital: "20-Year Capital Needs",
      projectName: "Projects",
      budget: "Budget",
      fundingSource: "Funding Source",
      projectStatus: "Project Status",
    });
  }
  private getSummary() {
    this._download.push({
      areaOfwork: "Total",
      fiveYrCapital: currencyFormatter.format(
        this._development.areasOfWork
          .flatMap((x) => x.fiveYearCapitalNeeds)
          .reduce((acc, cur) => acc + Number(cur), 0),
      ),
      twentyYrCapital: currencyFormatter.format(
        this._development.areasOfWork
          .flatMap((x) => x.twentyYearCapitalNeeds)
          .reduce((acc, cur) => acc + Number(cur), 0),
      ),
      projectName: "",
      budget: currencyFormatter.format(this._development.totalInvestment),
      fundingSource: "",
      projectStatus: "",
    });
  }

  getProjectstatus(proj: Project): string {
    this.projectStatus = [];
    this.projectStatus.push(proj.projectStatus);

    this.projectStatus.push(
      ...proj.schedule
        .filter((x) => Number(x.percentageCompleted) < 100 && Number(x.percentageCompleted) !== 0)
        .flatMap((v) => v.masterTaskName),
    );
    return this.projectStatus.filter((item, pos, ar) => ar.indexOf(item) === pos).join(", ");
  }
  downloadCSV(): void {
    this.excelService.exportExcelFile(this._download, this._development.name);
  }
}
